import * as THREE from 'three'
import React, { useRef } from 'react'
import { useLoader } from "react-three-fiber"
import { TextureLoader } from "three"
const image = './newspaper-texture.png'

const Ground = (props) => {
	const ref = useRef(null)
	const texture = useLoader(TextureLoader, image)
	texture.repeat.set(4, 4)
	texture.wrapS = THREE.RepeatWrapping
	texture.wrapT = THREE.RepeatWrapping

	return (
		<mesh ref={ref} name="URB/ZOO:ground" position={props.position} rotation={[-Math.PI / 2, 0, 0]}>
			<planeBufferGeometry attach="geometry" args={props.size} />
			<meshBasicMaterial attach="material" color={props.color} map={texture} />
		</mesh>
	)
}

export default Ground